import script from "./RegionTop.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegionTop.vue?vue&type=script&setup=true&lang=ts"

import "./RegionTop.vue?vue&type=style&index=0&id=162d3419&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-162d3419"]])

export default __exports__